import React from 'react';
import HelpContent from './HelpContent';
//import proyeccionParticipacion from 'img/proyeccion_participacion.png';

const TransportePublicoHelp = () => (
  <HelpContent>
    <h1>Transporte Publico</h1>
    <p>
    Esta medida analiza el impacto del aumento de la participación del transporte público. De acuerdo a la última Encuesta Origen-Destino para Santiago 
    del año 2015, el 28,7% de los viajes urbanos se realizaron en transporte público, mientras el 38,7% en medios no motorizados y 32,6% en modo particular.
    La participación del transporte público es utilizada en promedio 30,4%, siendo la Arica la ciudad en donde tiene una menor participación (23%), y
    Temuco la con mayor participación (35%). Respecto a la participación del uso de vehículos particulares, en promedio tiene una utilización de 38,6% en 
    el total de los viajes, para las ciudades analizadas.
    </p>

    <p>
    La introducción masiva de este tipo de transporte deberá considerar variables de calidad, tiempos de viajes y confort, para que sea una alternativa 
    viable al transporte privado. Esta medida se modela como traspaso modal a metro y tren, es decir, disminuye la demanda en transporte privado.
    </p>
    
    <p>
    <strong>Trayectoria 1:</strong> principalmente se modela una disminución de 135 millones de km anuales de la demanda de vehículos livianos debido al traspaso modal a metro y 
    35 millones de km anuales por traspaso modal a tren.
    </p>

  </HelpContent>
);

export default TransportePublicoHelp;
